<div class="idle-dialog">
    <div class="idle-dialog__accent"></div>

    <div class="idle-dialog__content">
        <div class="idle-dialog__icon" aria-hidden="true">
            <mat-icon svgIcon="heroicons_outline:clock"></mat-icon>
        </div>

        <div class="idle-dialog__eyebrow">Session security</div>
        <h2 mat-dialog-title>Are you still active?</h2>
        <p class="idle-dialog__message">
            You have been inactive for 30 minutes. To protect your account, BOSS
            will sign you out automatically.
        </p>

        <div
            class="idle-dialog__countdown"
            role="timer"
            aria-live="polite"
            aria-label="Time remaining before automatic sign out"
        >
            <div>
                <strong>{{ minutes }}</strong>
                <span>{{
                    minutes | i18nPlural: { '=1': 'minute', other: 'minutes' }
                }}</span>
            </div>
            <span class="idle-dialog__separator">:</span>
            <div>
                <strong>{{ seconds.toString().padStart(2, '0') }}</strong>
                <span>seconds</span>
            </div>
        </div>

        <p class="idle-dialog__hint">
            Unsaved changes may be lost when your session ends.
        </p>
    </div>

    <mat-dialog-actions>
        <button mat-button type="button" (click)="signOut()">
            Sign out now
        </button>
        <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="staySignedIn()"
        >
            <mat-icon svgIcon="heroicons_outline:check"></mat-icon>
            Stay signed in
        </button>
    </mat-dialog-actions>
</div>
